<template>
  <div class="focus-plus-campaign-banner text-center px-5 py-3">
    <a :href="FOCUS_URL" target="_blank">
      Jetzt Code <strong>&nbsp;{{ FOCUS_COUPON_CODE }}&nbsp;</strong>
    </a>
    einlösen und
    <a :href="FOCUS_URL" target="_blank">
      <img
        class="focus-plus-campaign-banner-image"
        width="135"
        height="55"
        :src="FOCUS_IMAGE"
        alt="Focus Plus Campaign"
        style="vertical-align: middle"
      />
    </a>
    einen Monat gratis testen. Mit
    <a :href="FOCUS_URL" target="_blank"> <strong>FOCUS+</strong> </a> erhalten
    Sie Zugang zu allen Inhalten der FOCUS- und FOCUS MONEY-Markenwelt plus
    exklusive Hintergründe, Analysen und Reportagen aus Politik, Wirtschaft,
    Wissenschaft und Finanzen.
    <br />
    <small>
      Alle Preise inkl. MwSt. Die ersten 4 Wochen für 0,00 €. Danach 4,29
      €/Woche mit Abrechnung alle 4 Wochen zum Preis von 17,16 €. Jederzeit zum
      Ende der jeweiligen Abrechnungsperiode kündbar. Angebot gilt nur für FOCUS
      Online Shopping Deals Kunden.
    </small>
  </div>
</template>

<script setup>
const FOCUS_COUPON_CODE = 'UHCZY3JJ1B'
const FOCUS_URL =
  'https://www.focusplus.de/?weindeal?utm_source=fol_deals&utm_medium=email&utm_campaign=shopping_deals&utm_content=sonderangebot_1monat'
const FOCUS_IMAGE = new URL('@/assets/images/focus+_logo.png', import.meta.url)
  .href
</script>
